import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {

  const [user, setUser] = useState(() => {
  const stored = localStorage.getItem("spectraUser");

  try {
    return stored ? JSON.parse(stored) : null;
  } catch (err) {
    console.warn("Invalid user in localStorage. Clearing.");
    localStorage.removeItem("spectraUser");
    return null;
  }
});

  const login = ({ username, account_id }) => {

  const userData = {
    username,
    account_id
  };

  localStorage.setItem("spectraUser", JSON.stringify(userData));
  setUser(userData);
};

 const logout = () => {

  if (user?.username) {
    localStorage.removeItem(`accountStatus_${user.username}`);
  }

  setUser(null);
  localStorage.removeItem("spectraUser");
  localStorage.removeItem("spectraToken");

  // Hard redirect (not React Router's navigate) so the authenticated page
  // is fully torn down and dropped from browser history, not just routed
  // away from within the same SPA instance.
  window.location.replace("/signin");
};

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}